import { PrivateRouteProps } from ".";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import useEffectOnce from "hooks/useEffectOnce";
import ToasterService from "utils/toaster.util";

export default function PrivateRoute({
	children,
	roles = [],
}: PrivateRouteProps) {
	let authenticated = true;
	const token = localStorage.getItem("jtoken")
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const tokenParams = searchParams.get("token");
	
	if (!token) authenticated = false;
	if (tokenParams) {
		localStorage.setItem("jtoken", `Bearer ${tokenParams}`);
		authenticated = true;
	}

	useEffectOnce(() => {
		if (!authenticated) {
			navigate('/not-authorize')
			setTimeout(() => ToasterService.showError("Something went wrong!"), 0);
		}
	});

	return <>{authenticated ? children : <Navigate to="/" />}</>;
}
